import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Avatar } from 'antd';
import { Link } from 'react-router-dom';
import Tab from '../Tab';
import Layout from '../Layout';
import ErrorAlert from '../../components/ErrorAlert';
import { get, remove, resetState } from '../../modules/categories';
import { buildCategoryPath } from '../../utils';

class CategoriesTab extends Tab {

  columns = [
    { key: 'id', title: 'ID', dataIndex: 'id' },
    {
      key: 'logo',
      title: 'Icon',
      dataIndex: 'logo',
      render: (logo) => {
        return (
          <Avatar
            size="large"
            src={logo}
          />
        );
      },
    },
    {
      key: 'name',
      title: 'Name',
      dataIndex: 'name',
      render: (name, data) => {
        return (
          <span>
            <Link to={`/categories/${data.id}`}>
              {buildCategoryPath(name, data, this.props.data.results, 0)}
            </Link>
          </span>
        );
      },
    },
    this.tableActions(),
  ];

  render() {
    return (
      <Layout>
        <ErrorAlert error={this.props.error} />
        <Row type="flex" justify="end">
          <Col md={3} lg={2}>
            {this.renderCreateButton()}
          </Col>
        </Row>
        <div className="container">
          <Row>
            <Col>
              {this.renderDataTable()}
            </Col>
          </Row>
        </div>
      </Layout>
    );
  }
}

export default connect(state => state.categories, { get, remove, resetState })(CategoriesTab);



// WEBPACK FOOTER //
// ./src/containers/Categories/CategoriesTab.js